import React from 'react'
import { Brakets } from 'Assets/icons/Brakets'
import { PapperplaneIcon } from 'Assets/icons/PaperplaneIcon'
import { WordPressIcon } from 'Assets/icons/WordPressIcon'
import { TagManagerIcon } from 'Assets/icons/TagManagerIcon'

export const GetTagMethods = [
  'googleTagManager',
  'wordpressPlugin',
  'directInstallation',
  'emailDev',
] as const

export type GetTagMethod = (typeof GetTagMethods)[number]

export const GetTagMethodIcons = {
  googleTagManager: <TagManagerIcon width={49} height={48} />,
  wordpressPlugin: <WordPressIcon width={49} height={48} />,
  directInstallation: <Brakets width={49} height={48} />,
  emailDev: <PapperplaneIcon width={49} height={48} />,
}

export const SmallGetTagMethodIcons = {
  googleTagManager: <TagManagerIcon width={24} height={24} />,
  wordpressPlugin: <WordPressIcon width={24} height={24} />,
  directInstallation: <Brakets width={24} height={24} />,
  emailDev: <PapperplaneIcon width={24} height={24} />,
}
